import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ImmutablePureComponent from 'react-immutable-pure-component'
import Layout from './layout'

class BusinessLayout extends ImmutablePureComponent {

  render() {
    const {
      children,
      title,
      tabs,
      noRightSidebar,
      sidebarChildren,
      actions,
      button,
      search,
      layout,
      showBackBtn,
      noSidebar,
    } = this.props

    return (
      <Layout
        showGlobalFooter
        showNormalSidebar
        noComposeButton
        noSidebar={noSidebar}
        showLinkFooterInSidebar
        showBackBtn={showBackBtn}
        page='business'
        tabs={tabs}
        title={title}
        noRightSidebar={noRightSidebar}
        sidebarChildren={sidebarChildren}
        actions={actions}
        button={button}
        search={search}
        layout={layout}
      >
        <div className={[_s.d, _s.w100PC].join(' ')}>
          {/* <BusinessNavigationBar /> */}
          {children}
        </div>
      </Layout>
    )
  }

}

BusinessLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  noRightSidebar: PropTypes.bool,
  sidebarChildren: PropTypes.node,
}

export default BusinessLayout